import { AnalyticsEvent } from '../../../../event'
import { GlobalDataFormatter } from '../../formatters/global-data'
import { PageEvents } from '../../page-events'

const mParticleEvents: PageEvents = new PageEvents()

export class Video extends AnalyticsEvent {

    /**
     * Handle event with detail
     */
    public handleWithDetail(event: CustomEvent): void {

        /**
         * Event Handler: create Attributes list and send it to mParticle
         * @var attrs will be different for each event
         *
         */

        this.eventData = this.eventData || this.getProperties()
        const staticEventData = this.eventData  // save a copy of static event data
        let controlFields = this.getControlFields()
        // add dynamic event detail to static event data (custom attributes and control fields)
        if (event.detail) {
            this.eventData = {...this.eventData, ...event.detail,
                control_fields: {...controlFields, ...event.detail.control_fields}
            }
        }
        controlFields = this.getControlFields() // get control fields again, after adding the dynamic control fields

         // Get attributes list
        const dataAttrs = this.getAttributesList()

        // Get Data Values
        const globalFormatter = new GlobalDataFormatter(this.metaProperties)
        let data: any = {}
        dataAttrs.forEach((attr) => {
            try {
                const attrValue = globalFormatter.lookup(attr)
                if(attrValue !== '') {
                    data[attr] = attrValue
                }
            } catch(e) {
                console.error('GlobalDataFormatter error', e)
            }
        })

        // Add custom element data to Event Data
        data = {...data, ...this.getCustomElementData()}
        const mpCustomFlag: {} = controlFields.ga_non_interaction? {'Google.NonInteraction': true}:{}
        const mpEventType: string = controlFields.mp_event_type || 'Other'
        // video center videos become interaction (user has to click play) for small screen size (dynamic)
        // event name: video-interaction or video-non-interaction
        this.type = controlFields.event_name? controlFields.event_name: this.type
        mParticleEvents.logEvent(
            this.type,
            PageEvents.mpEventType[mpEventType],
            data,
            mpCustomFlag
        )

        // recover static event data (remove any dynamic data added during the current event)
        // for instance, "Video Started": "true", should be removed from custom attributes
        // so that it is not included when the "Video Complete": "true" attribute is sent in a later event
        this.eventData = staticEventData
    }
}
